"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckIcon = function CheckIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      viewBox = _ref.viewBox,
      fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_SVG.default, {
    style: style,
    width: width || '32',
    height: height || '32',
    viewBox: viewBox || '0 0 32 32',
    fill: fill,
    className: className,
    path: "M13.6421 19.6236L24.3865 9.2883C24.7753 8.9039 25.4056 8.9039 25.7944 9.2883C26.1831 9.6727 26.1831 10.2959 25.7944 10.6803L14.346 21.7117C13.9573 22.0961 13.3269 22.0961 12.9382 21.7117L7.37751 16.0941C6.98875 15.7097 6.98875 15.0864 7.37751 14.702C7.76628 14.3176 8.3966 14.3176 8.78537 14.702L13.6421 19.6236Z"
  });
};

var _default = CheckIcon;
exports.default = _default;